import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function InternalTabListItem(props) {
  const { active, onClick, text } = props;

  const tabListItemClassNames = classNames(
    'tabbed-content__tab-list-item',
    { 'tabbed-content__tab-list-item--active': active },
  );

  return (
    <button
      className={tabListItemClassNames}
      onClick={onClick}
      type="button"
    >
      { text }
    </button>
  );
}

InternalTabListItem.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

InternalTabListItem.defaultProps = {
  active: false,
};

export default InternalTabListItem;
